import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { TestBoundary } from './TestBoundary.js';

const root = document.querySelector<HTMLDivElement>('#root');
if (!root) throw new Error('Back Office root element was not found');
createRoot(root).render(<StrictMode><TestBoundary><App /></TestBoundary></StrictMode>);
